module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b279390376a92ec00c0fc8b7dc09886c.gif";